import { render, staticRenderFns } from "./AssignmentOverall.vue?vue&type=template&id=20c5a381&scoped=true&"
import script from "./AssignmentOverall.vue?vue&type=script&lang=js&"
export * from "./AssignmentOverall.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentOverall.vue?vue&type=style&index=0&id=20c5a381&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5a381",
  null
  
)

export default component.exports